import React from 'react';
import { useTranslation } from 'react-i18next';

function getTelHref(phoneText) {
  if (!phoneText) return '#';
  const digits = phoneText.replace(/\s/g, '').replace(/[^\d+]/g, '');
  return digits ? `tel:${digits}` : `tel:${phoneText.trim()}`;
}

export default function StickyFooter() {
  const { t } = useTranslation();
  const phoneNumber = t('common.footer.phone-number');
  const telHref = getTelHref(phoneNumber);

  return (
    <footer
      className="mt-auto border-t border-gray-200 bg-white shadow-[0_-2px_10px_rgba(0,0,0,0.06)]"
      role="contentinfo"
    >
      <div
        className="mx-auto max-w-screen-xl px-4 py-4 sm:py-5"
        style={{ paddingBottom: 'max(1rem, env(safe-area-inset-bottom, 0px))' }}
      >
        <div className="flex flex-col items-center md:gap-10 gap-2 text-center sm:flex-row sm:justify-center sm:gap-8 sm:text-left">
          <span className="text-sm font-medium text-gray-600 sm:text-base">
            {t('common.footer.questions')}
          </span>
          <a
            href={telHref}
            className="inline-flex items-center gap-1.5 text-base font-bold text-primary underline decoration-2 underline-offset-2 transition-[color,text-decoration-color] hover:text-blue-700 hover:decoration-blue-700 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 rounded sm:text-lg cursor-pointer"
            aria-label={t('common.footer.call') || `Call ${phoneNumber}`}
          >
            <svg
              className="h-5 w-5 shrink-0 text-primary"
              aria-hidden="true"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fillRule="evenodd"
                d="M2 3.5A1.5 1.5 0 013.5 2h1.148a1.5 1.5 0 011.465 1.175l.716 3.223a1.5 1.5 0 01-1.052 1.767l-.933.267c-.41.117-.643.555-.48.95a11.542 11.542 0 006.254 6.254c.395.163.833-.07.95-.48l.267-.933a1.5 1.5 0 011.767-1.052l3.223.716A1.5 1.5 0 0118 15.352V16.5a1.5 1.5 0 01-1.5 1.5H15c-1.149 0-2.263-.15-3.326-.43A13.022 13.022 0 012.43 8.326 13.019 13.019 0 012 5V3.5z"
                clipRule="evenodd"
              />
            </svg>
            {phoneNumber}
          </a>
          <span className="text-xs font-medium text-gray-600 sm:text-base">
            {t('common.footer.availablity-times')}
          </span>
        </div>
      </div>
    </footer>
  );
}
